<template>
    <div class="master-section row justify-content-between px-0 px-md-1 mb-40px triple-column-layout mb-md-60px">
		<div class="col-12 col-md-4" v-for="(item, id_item) in triple_column" :key="id_item" :class="textPlacementClass(id_item)">
			<a v-if="item.link_type=='section'" class="master-section-link" :href="item.button_link.url" :target="item.button_link.target || '_self'">
				<div class="img-fluid-wrapper mb-md-25px mb-25px">
					<img class="img-fluid" :src="item.media.image_full" :alt="item.media.alt ?? ''">
				</div>
				<h3 v-if="item.title && item.title.trim()" class="mb-25px px-15">{{ item.title }}</h3>
				<div class="px-15" v-html="item.description"></div>
			</a>
			<template v-if="item.link_type=='button' || item.link_type=='none'">
				<img class="img-fluid mb-md-25px mb-25px" :src="item.media.image_full" :alt="item.media.alt ?? ''">
				<h3 v-if="item.title && item.title.trim()" class="mb-25px px-15">{{ item.title }}</h3>
				<div class="px-15" v-html="item.description"></div>
				<a v-if="item.button_link.title && item.link_type !=='none'" class="btn-outline-dark btn" style="margin-top: 16px" :href="getLangUrl(item.button_link.url, baseUrl, locale)" :target="item.button_link.target || '_self'">
					{{ item.button_link.title}}
					<span style="border-color: #000000" class="css-arrow css-arrow-right"></span>
				</a> 
			</template>
		</div>
	</div>
</template>

<script lang="ts" setup>
    import { ref } from 'vue';
	const props = defineProps(["data"]);
    const triple_column = computed(() => props.data);
	const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { convertUrlsToLocale, getLangUrl } from '~/utils/getLangUrl';
	
	function textPlacementClass(placement:any) {
        switch (placement) {
            case 0:
                return 'pl-md-0 pr-md-2 mb-md-0px mb-25px';
            case 1:
                return 'pl-md-0 pr-md-0 px-md-1 mb-md-0px mb-25px';
            case 2:
                return 'pl-md-2 pr-md-0';
            default:
                return '';
        }
    }
</script>